<template>
  <div id="app" class="app">
    <router-view />
  </div>
</template>

<script>
import {
  ColorThemeActionsMixin,
  ColorThemeMixin,
} from '@/services/vuestic-ui'
export default {
  name: 'app',
  mixins: [ColorThemeActionsMixin, ColorThemeMixin],
  data () {
    return {
      // Temporary config for 2.1.
      contextConfig: {
        gradient: true,
        shadow: 'lg', // 3 states: 'sm', 'lg', undefined (no shadow).
        invertedColor: false,
      },
    }
  },
  provide () {
    return {
      contextConfig: this.contextConfig,
    }
  },
  watch: {
    // Temporary colors fix for 2.1.
    'contextConfig.invertedColor' (val) {
      const invertedColorClass = 'va-inverted-color'
      if (val) {
        document.body.classList.add(invertedColorClass)
      } else {
        document.body.classList.remove(invertedColorClass)
      }
    },
    $themes: {
      deep: true,
      handler () {
        const name = this.contextConfig.name ?? 'light'
        this.setColors(this.$themes)
        localStorage.setItem(
          'palette',
          JSON.stringify({ name, colors: this.$themes }),
        )
      },
    },
  },
}
</script>

<style lang="scss">
@import '../sass/main.scss';

body {
  height: 100%;
  color: var(--va-textColor);

  #app {
    height: 100%;
  }
}
</style>
